import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import AuthScreen from '../screens/authentication/AuthScreen';
import OnboardScreen from '../screens/authentication/OnboardScreen';
import { getFocusedRouteNameFromRoute } from '@react-navigation/native';
import AddToHomeScreen from '../components/common/AddToHomeScreen';

const Stack = createStackNavigator();
const INITIAL_ROUTE_NAME = 'Auth';

export default function StackNavigator({ navigation, route, setNavHeaderMode }) {
  // Set the header title on the parent stack navigator depending on the
  // currently active tab. Learn more in the documentation:
  // https://reactnavigation.org/docs/en/screen-options-resolution.html
  navigation.setOptions({ headerTitle: getHeaderTitle(route) });

  return (
    <>
      <AddToHomeScreen />
      <Stack.Navigator
        initialRouteName={INITIAL_ROUTE_NAME}
        headerMode="none">
        <Stack.Screen
          name="Auth"
          component={AuthScreen}
          options={{
            title: 'Welcome to Suplias'
          }}
        />
        <Stack.Screen
          name="Onboard"
          component={OnboardScreen}
          options={{
            title: 'Get started on Suplias'
          }}
        />
      </Stack.Navigator>
    </>
  );
}

function getHeaderTitle(route: any) {
  const routeName = getFocusedRouteNameFromRoute(route) ?? INITIAL_ROUTE_NAME;

  switch (routeName) {
    case 'Auth':
      return 'Sign in';
    case 'Onboard':
      return 'Get started';
    default:
      return routeName;
  }
}
